(function ($) {
    'use strict';
    $(function () {
        const container = $('.section__travel');

        if(!container.length || $(window).width() < 1200){
            return;
        }

        const fixedItem = $('.sticky-sidebar').offset().top; 
        $(window).scroll(function() {                  
            let currentScroll = $(window).scrollTop(); 

            if (currentScroll >= fixedItem) {           
                $('.sticky-sidebar').addClass('is-fixed');
            } else {                                
                $('.sticky-sidebar').removeClass('is-fixed');
            }
        });

        let links = $('.js-sticky-list-item a');
        links.on('click', function(){
            links.removeClass('active');
            $(this).addClass('active');
        });
       

    });
})(jQuery);